module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Hot.a5b9e7e4.svg";